module.exports = __webpack_public_path__ + "img/adobe-marketing-cloud.22a21d6d.svg";